import { ReactElement } from 'react';
import { CheckboxInput } from '@components';
import { useFormikContext, Field } from 'formik';
import { iFVSFormValues } from '@services/FVSService';

function FVSStep24(): ReactElement {
  const { values }: { values: iFVSFormValues } = useFormikContext();
  const firstParty = values.ApplicationLodger === 'LodgedByVictim';
  return (
    <>
      <div className="vfH2">Declaration</div>
      { firstParty ? (
        <div>
          <p>I authorise Fines Victoria to disclose my personal information to the enforcement agencies that issued the fine(s), the Magistrates’ Court of Victoria and any person whose evidence I rely on in support of this application, and</p>
          <p>The information supplied in this form is true and correct to the best of my knowledge, and</p>
          <p>I understand that by making a false or misleading statement in support of this application, I may be prosecuted.</p>
        </div>
      ) : (
        <div>
          <p>I have informed the applicant that their personal information may be disclosed to the enforcement agencies that issued the fine(s), the Magistrates’ Court of Victoria and any person whose evidence the applicant relies on in support of this application, and</p>
          <p>The information supplied on this form is true and correct to the best of my knowledge, and</p>
          <p>I understand that by making a false or misleading statement in support of this application, I may be prosecuted.</p>
        </div>
      )}

      <Field component={CheckboxInput} name="declaration" title="I agree to the statements above" />
    </>
  );
}

export default FVSStep24;
